"use strict";
/**
 * Central type definitions for player data fields.
 * PlayerDataFieldDef is the single source of truth driving:
 *   - Player roster columns (GroupEditor DataGridPro)
 *   - Registration form fields (RegistrationTab / RegistrationPopout)
 *   - Player upload template columns (CSV upload)
 */
Object.defineProperty(exports, "__esModule", { value: true });
